import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { submitOtp } from "../../actions";
import Modal, { ModalBody, ModalFooter, ModalHeader } from "../ui/Modal";
import { Field, Input } from "../ui/Field";
import { Button } from "../ui/Button";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const DEFAULT_DATA = { email: "", code: "" };

export default function OTPDialog({ openDialog, handleCloseDialog, onSubmit }) {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(DEFAULT_DATA);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => setOpen(openDialog), [openDialog]);

  const close = () => {
    setOpen(false);
    if (handleCloseDialog) handleCloseDialog(false);
  };

  const change = (key) => (e) => setData({ ...data, [key]: e.target.value });

  const submit = () => {
    dispatch(
      submitOtp(
        data,
        () => onSubmit(data),
        ({ response }) =>
          setSnackbar({
            open: true,
            message:
              response?.data?.msg ||
              "Oops! Something went wrong. Contact your system administrator.",
            severity: "error",
          })
      )
    );
  };

  const disabled = !data.email || !data.code;

  return (
    <>
      <Modal open={open} onClose={close} maxWidth="max-w-md">
        <ModalHeader
          title="Verify your email"
          subtitle="We sent a one-time code to your inbox. Check spam if you don't see it."
          onClose={close}
        />
        <ModalBody className="space-y-4">
          <Field label="Email">
            <Input
              type="email"
              placeholder="you@lab.edu"
              value={data.email}
              onChange={change("email")}
            />
          </Field>
          <Field label="One-time code">
            <Input
              inputMode="numeric"
              autoComplete="one-time-code"
              placeholder="000000"
              value={data.code}
              onChange={change("code")}
              className="mono tracking-[0.4em] text-center text-lg"
            />
          </Field>
        </ModalBody>
        <ModalFooter>
          <Button onClick={submit} disabled={disabled} className="w-full">
            Verify
          </Button>
        </ModalFooter>
      </Modal>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}
